import { FunctionComponent, ReactNode } from 'react';
import { useLocalStorageState } from 'ahooks';
import { t } from '@lingui/macro';
import AntdResult from '@core/components/AntdResult';
import { LOCALSTORAGE_PERMISSION_KEY } from '@core/constants';

type Props = {
    mode?: 'page' | 'component';
    permission: string | null;
    children: ReactNode;
};

/**
 * @desc 处理页面级别 permission
 * @param {string | null} permission 权限 code
 * @param {type} [mode] 模式-组件、页面
 * @returns ReactElement
 */
const RequireAuth: FunctionComponent<Props> = (props) => {
    const [permissions] = useLocalStorageState<string[] | undefined>(LOCALSTORAGE_PERMISSION_KEY, undefined);

    if (!permissions || !props.permission) {
        return <>{props.children}</>;
    }

    const flag = permissions.includes(props.permission);

    if (flag === true) return <>{props.children}</>;

    return props.mode === 'page' ? <AntdResult subTitle={t`No Permission`}></AntdResult> : <></>;
};

RequireAuth.defaultProps = {
    mode: 'component',
};

export default RequireAuth;
